module.exports = __webpack_public_path__ + "ef91e7e572e3e24da18cfd8ee71798cd.pdf";